import { Reservation } from "@/types/reservation";

export const exportReservationsToCSV = (
  reservations: Reservation[],
  filename: string = "reservations.csv",
) => {
  const headers = [
    "Reservation Number",
    "Guest Name",
    "Phone",
    "Email",
    "Country",
    "Adults",
    "Children",
    "Room Number",
    "Room Type",
    "Check In",
    "Check Out",
    "Status",
    "Guest Status",
    "Balance",
    "Currency",
    "Booking Source",
    "Notes",
    "Created At",
  ];

  const csvContent = [
    headers.join(","),
    ...reservations.map((reservation) =>
      [
        `"${reservation.reservationNumber}"`,
        `"${reservation.guest.name}"`,
        `"${reservation.guest.phone || ""}"`,
        `"${reservation.guest.email || ""}"`,
        `"${reservation.guest.nationality || ""}"`,
        reservation.guest.adults,
        reservation.guest.children,
        reservation.roomNumber,
        `"${reservation.roomType}"`,
        `"${new Date(reservation.checkIn).toLocaleDateString()}"`,
        `"${new Date(reservation.checkOut).toLocaleDateString()}"`,
        `"${reservation.status}"`,
        `"${reservation.guestStatus}"`,
        reservation.balance || 0,
        `"${reservation.currency || "$"}"`,
        `"${reservation.bookingSource || "N/A"}"`,
        `"${reservation.notes || ""}"`,
        `"${new Date(reservation.createdAt).toLocaleDateString()}"`,
      ].join(","),
    ),
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");

  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const formatDateForCSV = (dateString: string): string => {
  try {
    return new Date(dateString).toLocaleDateString();
  } catch {
    return dateString;
  }
};

export const escapeCSVField = (
  field: string | number | null | undefined,
): string => {
  if (field === null || field === undefined) return '""';
  const stringField = String(field);
  if (
    stringField.includes(",") ||
    stringField.includes('"') ||
    stringField.includes("\n")
  ) {
    return `"${stringField.replace(/"/g, '""')}"`;
  }
  return `"${stringField}"`;
};
